module.exports = require("@workbench-stack/settings");